<template>
    <div class="home">
        <!-- Header -->
        <HeaderComponent />

        <!-- Sticky Navigation -->
        <NavigationComponent :is-sticky="isNavSticky" :active-section="activeSection" @navigate="handleNavigation" />

        <!-- Main Content Sections -->
        <main>
            <!-- Video Section - Interview -->
            <VideoSection />

            <!-- Profile Section - Sylvia Braun -->
            <section id="sylvia-braun" ref="sylviaBraunSection">
                <ProfileSection @show-profile="goToProfile" @show-goals="goToGoals" @show-termine="goToTermine" />
            </section>

            <!-- Projects Section -->
            <section id="projects" ref="projectsSection">
                <ProjectsSection />
            </section>

            <!-- Contact Section - Ask Questions -->
            <section id="ask-questions" ref="askQuestionsSection">
                <ContactSection />
            </section>
        </main>



        <!-- Footer -->
        <FooterComponent />
    </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import NavigationComponent from '@/components/NavigationComponent.vue'
import VideoSection from '@/components/VideoSection.vue'
import ProfileSection from '@/components/ProfileSection.vue'
import ProjectsSection from '@/components/ProjectsSection.vue'
import ContactSection from '@/components/ContactSection.vue'

import FooterComponent from '@/components/FooterComponent.vue'

export default {
    name: 'HomeView',
    components: {
        HeaderComponent,
        NavigationComponent,
        VideoSection,
        ProfileSection,
        ProjectsSection,
        ContactSection,

        FooterComponent
    },
    data() {
        return {
            isNavSticky: false,
            activeSection: 'sylvia-braun',

            sections: ['sylvia-braun', 'projects', 'ask-questions']
        }
    },
    mounted() {
        this.handleScroll()
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        handleScroll() {
            const header = document.querySelector('.header-component')
            const headerHeight = header ? header.offsetHeight : 0

            // Check if navigation should be sticky
            this.isNavSticky = window.scrollY >= headerHeight

            // Update active section based on scroll position
            this.updateActiveSection()
        },
        updateActiveSection() {
            const scrollPos = window.scrollY + 150 // Offset for better UX

            // Get all sections
            const sections = [
                { id: 'sylvia-braun', element: this.$refs.sylviaBraunSection },
                { id: 'projects', element: this.$refs.projectsSection },
                { id: 'ask-questions', element: this.$refs.askQuestionsSection }
            ]

            // Find the current section
            let currentSection = 'sylvia-braun'

            for (let i = 0; i < sections.length; i++) {
                const section = sections[i]
                if (section.element) {
                    const sectionTop = section.element.offsetTop
                    const sectionHeight = section.element.offsetHeight
                    const sectionBottom = sectionTop + sectionHeight

                    if (scrollPos >= sectionTop - 150 && scrollPos < sectionBottom - 100) {
                        currentSection = section.id
                        break
                    }
                }
            }

            // Special handling for the last section
            const lastSection = sections[sections.length - 1]
            if (lastSection.element) {
                const lastSectionTop = lastSection.element.offsetTop
                if (scrollPos >= lastSectionTop - 200) {
                    currentSection = lastSection.id
                }
            }

            this.activeSection = currentSection
        },
        handleNavigation(sectionId) {
            const element = document.getElementById(sectionId)
            if (element) {
                const navigationHeight = 80 // Account for sticky nav height
                const elementPosition = element.offsetTop - navigationHeight

                window.scrollTo({
                    top: elementPosition,
                    behavior: 'smooth'
                })
            }
        },
        goToProfile() {
            this.$router.push('/profile')
        },
        goToGoals() {
            this.$router.push('/goals')
        },
        goToTermine() {
            this.$router.push('/termine')
        },

    }
}
</script>